export default {
  "primaryColor": "#d94353",
  "lightColor": "#ee7e8f",
  "darkColor": "#ae3552"
};